import React from "react";
import "./conclave css files/stepsection.css";
const design_9 = require("../../assets/conclave assets/green_dots.png");

const allThreeContent = [
  {
    numberContent: "01",
    extraContent: ` The Conclave will talk about where Indian youths are positioned,
        in terms of their understanding, skill set and where they would
        like to reach. Also what are the policy changes required and the
        view point of our stake owners in the Government education
        regulatory bodies to truly make these youths embody the global
        citizenship.`,
    colorName: "#b7b7b9",
  },
  {
    numberContent: "02",
    extraContent: `It will not only focus on the advantages of WHY STUDY 
    ABROAD, but will also open doors 
    for Indian Institutions (Schools 
    Colleges & Universities) and enable 
    them to network with Overseas 
    Institutions (also available at the 
    event) for Pathway programmes, 
    internship & global exchange 
    opportunities and Summer schools.`,
    colorName: "#c8c8ca",
  },
  {
    numberContent: "03",
    extraContent: `Identify the need of honing Entrepreneurial skills amongst the 
    Indian students from the early days 
    and how they can transition right 
    from high school & college days In 
    the direction of professional 
    working spaces through Design s
    Thinking & developing innovative 
    thinking patterns.`,
    colorName: "#d7d7d9",
  },
];

function StepSection(props) {
  return (
    <section className="step_section_main_container">
      <div className="step_section_under_main_container">
        <div className="design_title_container">
          <div className="design_9_container">
            <img src={design_9} alt="design9" />
          </div>
          <p className="title_of_step_section">
            3 Key Attributes expected post this conclave?
          </p>
        </div>

        <div className="design_three_step_container">
          {allThreeContent.map((perContent) => {
            return (
              <div
                className="design_green_dot_text_container"
                key={Math.random()}
              >
                <div className="design_one_step_container">
                  <strong
                    className="number_step_text"
                    style={{ color: perContent.colorName }}
                  >
                    {perContent.numberContent}
                  </strong>
                  <p className="paragraph_text_step">
                    {perContent.extraContent}
                  </p>
                </div>
                {perContent?.numberContent === "03" ? null : (
                  <div className="green_line_dot_container">
                    <div className="green_circle_container" />
                    <div className="vertical_line_container" />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default StepSection;
